export const PATIENT_TRANSFORM_FACTORS = {
    FITNESS: 'Fitness',
    HABITS: 'Intervention/Habits'
}

export const TRANSFORM_FACTORS = [
    PATIENT_TRANSFORM_FACTORS.FITNESS,
    PATIENT_TRANSFORM_FACTORS.HABITS
];

export const TRANSFORM_FACTORS_COLORS = {
    [PATIENT_TRANSFORM_FACTORS.FITNESS]: '#d5eef7',
    [PATIENT_TRANSFORM_FACTORS.HABITS]: '#a1d99e'
}